import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

function authHeaders() {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("Token no encontrado");
  return { Authorization: `Bearer ${token}` };
}

export const listResearchBrands = async (params = {}) => {
  const response = await axios.get(
    `${API_URL}/api/skill-agent-research-brands`,
    { headers: authHeaders(), params },
  );
  return response.data;
};

export const createResearchBrand = async (payload) => {
  const response = await axios.post(
    `${API_URL}/api/skill-agent-research-brands`,
    payload,
    { headers: authHeaders() },
  );
  return response.data;
};

export const updateResearchBrand = async (id, payload) => {
  const response = await axios.patch(
    `${API_URL}/api/skill-agent-research-brands/${id}`,
    payload,
    { headers: authHeaders() },
  );
  return response.data;
};

export const deleteResearchBrand = async (id) => {
  const response = await axios.delete(
    `${API_URL}/api/skill-agent-research-brands/${id}`,
    { headers: authHeaders() },
  );
  return response.data;
};

export const linkResearchBrandCustomer = async (brandId, customerId) => {
  const response = await axios.post(
    `${API_URL}/api/skill-agent-research-brands/${brandId}/customers/${customerId}`,
    {},
    { headers: authHeaders() },
  );
  return response.data;
};

export const unlinkResearchBrandCustomer = async (brandId, customerId) => {
  const response = await axios.delete(
    `${API_URL}/api/skill-agent-research-brands/${brandId}/customers/${customerId}`,
    { headers: authHeaders() },
  );
  return response.data;
};

export const addResearchBrandSource = async (brandId, payload) => {
  const response = await axios.post(
    `${API_URL}/api/skill-agent-research-brands/${brandId}/sources`,
    payload,
    { headers: authHeaders() },
  );
  return response.data;
};

export const updateResearchBrandSource = async (brandId, sourceId, payload) => {
  const response = await axios.patch(
    `${API_URL}/api/skill-agent-research-brands/${brandId}/sources/${sourceId}`,
    payload,
    { headers: authHeaders() },
  );
  return response.data;
};

export const deleteResearchBrandSource = async (brandId, sourceId) => {
  const response = await axios.delete(
    `${API_URL}/api/skill-agent-research-brands/${brandId}/sources/${sourceId}`,
    { headers: authHeaders() },
  );
  return response.data;
};

export const seedGuResearchBrands = async (customerId) => {
  const response = await axios.post(
    `${API_URL}/api/skill-agent-research-brands/seed-gu`,
    { customerId },
    { headers: authHeaders() },
  );
  return response.data;
};
